import mixins from 'synergycms_core/src/less/mixins';

export default {
  maxContainer: {},
  stepContainer: {},
  logoContainer: {},
  stepContent: {},
  step: {},
  staP2: {},
  staP3: {},
  defaultStyle: {
    backgroundColor: data => data.backgroundColor,
    textAlign: 'right',
    overflow: 'hidden',

    '& $maxContainer': {
      maxWidth: '1180px',
      margin: '0 auto',
      '&:lang(ar)': {
        textAlign: 'left',
      }
    },
    '& $stepContainer': {
      display: 'inline-block'
    },
    '& $logoContainer': {
      float: 'left',
      '&:lang(ar)': {
        float: 'right'
      }
    },
    '& $stepContent': {
      counterReset: 'pasos',
      position: 'relative',
      zIndex: '0',
      fontSize: '1px',
      overflow: 'hidden',
      padding: '0',
      margin: '0',
      display:'flex',
      '&:before,&:after': {
        content: "''",
        borderTop:data => '2px solid ' + data.headerColorDynamicText,
        position: 'absolute',
        left: '0',
        top: '50%',
        width: '100%',
        marginTop: '-1px',
        zIndex: '-1'
      },
      '& $step': {
        backgroundColor: data => data.backgroundColor,
        border:data => '2px solid ' + data.headerColorDynamicText,
        ...mixins.mixinBorderRadius('50%'),
        display: 'inline-block',
        position: 'relative',
        color: data=> data.headerColorDynamicText,
        height: '30px',
        width: '30px',
        '&:after': {
          counterIncrement: 'pasos',
          content: 'counter(pasos)',
          font: "bold 16px/1px 'Roboto', sans-serif",
          textAlign: 'center',
          position: 'absolute',
          marginTop: '-1px',
          left: '0',
          right: '0',
          top: '50%'
        },
        '&:first-of-type': {
          color: data => data.headerColorIcons,
          borderColor: data => data.headerColorIcons
        },
        '&:not(:last-of-type)': {
          marginRight: '30px',
          '&:lang(ar)': {
            marginRight: 0,
            marginLeft: '30px'
          }
        }
      },
      '&:lang(ar)': {
        '&:after': {
          width: '50%',
          left: 'auto',
          right: '0',
        }
      }
    },
    '&$staP2': {
      '& ul': {
        '&:after': {
          width: '100%!important',
          borderTopColor: data => data.headerColorIcons
        },
        '& li:nth-of-type(2)': {
          borderColor: data => data.headerColorIcons,
          color: data => data.headerColorIcons,
          '&:after': {
            color: data => data.headerColorIcons
          }
        }
      }
    },
    '&$staP3': {
      '& li:nth-of-type(3)': {
        borderColor: data => data.headerColorIcons,
        color: data => data.headerColorIcons,
        '&:after': {
          color: data => data.headerColorIcons
        }
      }
    },
  }
};
